import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-200 transition-all duration-300 flex flex-col sm:flex-row">
      <Link to={`/article/${article.slug}`} className="block sm:w-48 lg:w-56 shrink-0 aspect-video sm:aspect-auto overflow-hidden">
        <img
          src={article.image}
          alt={article.title}
          title={`${article.title} - 私密视频`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </Link>
      <div className="p-4 flex flex-col justify-between flex-1">
        <div>
          <Link to={`/article/${article.slug}`} className="block">
            <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-2 leading-snug group-hover:text-accent-600 transition-colors duration-200 mb-2">
              {article.title}
            </h3>
          </Link>
          <p className="text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed">
            {article.excerpt}
          </p>
        </div>
        <div className="flex items-center justify-between mt-3 text-xs text-foreground-500">
          <div className="flex items-center gap-3">
            <span>
              <i className="ri-calendar-line mr-1"></i>{article.date}
            </span>
            <span>
              <i className="ri-time-line mr-1"></i>{article.readTime}
            </span>
          </div>
          <span className="text-accent-600 font-medium group-hover:underline whitespace-nowrap">
            阅读全文 <i className="ri-arrow-right-line ml-1"></i>
          </span>
        </div>
      </div>
    </article>
  );
}